import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;

  .page-enter {
    opacity: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-60%);
    width: calc(100% - 2em);
  }

  .page-enter-active {
    opacity: 1;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    transition: all 500ms;
    width: calc(100% - 2em);
  }

  .page-exit {
    opacity: 1;
    transform: translateX(-50%);
    left: 50%;
    position: absolute;
    width: calc(100% - 2em);
  }

  .page-exit-active {
    opacity: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-40%);
    transition: all 500ms;
    width: calc(100% - 2em);
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-flow: column;

  @media only screen and (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 1rem;
  }
`;
